export default __webpack_public_path__ + "static/media/broken-car-replacement.eadc0120.jpg";